module.exports = __webpack_public_path__ + "static/media/community.0a00231b.png";